import React, {useState} from 'react';
import "../css/reportComment.css";
import {BASE_URL} from "../constants";
import { useLanguage } from "../components/Language.js";

function CommentReportForm({ comment_id, onClose }) {

    const [reportTitle, setReportTitle] = useState("");
    const [reportReason, setReportReason] = useState("");

    const {language} = useLanguage();

    const translations = {
        en: {
            hereToReport: "Why are you reporting this comment?",
            reportTitle: "report title",
            reason: "Please provide a reason for reporting this comment...",
            Close: "Close",
            sendReport: "Send Report",
            cancel: "Cancel",
        },

        gd: {
            hereToReport: "Thoir seachad adhbhar airson an abairt seo aithris, mas e do thoil e ...",
            reportTitle: "report title",
            reason: "Please provide a reason for reporting this comment...",
            Close: "Close", 
            sendReport: "Cuir air falbh an aithisg",
            cancel: "Dubh às",
        },
    };

    const handleSubmit = async () => {
        
        const response = await fetch(`${BASE_URL}/api/save_comment_report/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "reported_comment_id": comment_id,
                "report_title": reportTitle,
                "report_content": reportReason}),

        })

        if (response.ok){
            document.getElementById("report-comment-form").reset();
        }

    };


    return(
        <div>
        <h3>{translations[language].hereToReport}</h3>
        <form onSubmit={handleSubmit} id="report-comment-form">
            <input
                required
                type="text"
                id="title"
                placeholder="report title"
                value={reportTitle}
                className="user-report-input-box-long"
                onChange={(e) => setReportTitle(e.target.value)}
            />

            <textarea
                required
                value={reportReason}
                onChange={(e) => setReportReason(e.target.value)}
                placeholder="Please provide a reason for reporting this comment..."
                rows="4"
                cols="50"
            ></textarea>
            <br />

            <button type="submit" id="send-comment-report">{translations[language].sendReport}</button>
            <button id="cancel-comment-report" onClick={onClose}>{translations[language].cancel}</button>
        </form>
    </div>
    );
}

export default CommentReportForm;